<!-- 基础布局 -->
<template>
  <section class="app-main" id="appMain">
    <transition name="fade-transform" mode="out-in">
      <keep-alive >
        <router-view :key="Math.random()" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    }
  },
  data(){
    return {

    }
  },
  methods:{

  },
  watch:{

  }
}
</script>

<style scoped>
.app-main{
  position: relative;
  height: calc(100% - 31px);
}
</style>



// WEBPACK FOOTER //
// src/layout/components/appMain.vue